import BakoSafe from "../../../components/icons/Wallets/BakoSafe"
import Ethereum from "../../../components/icons/Wallets/Ethereum"
import Fuel from "../../../components/icons/Wallets/Fuel"
import Fuelet from "../../../components/icons/Wallets/Fuelet"
import Solana from "../../../components/icons/Wallets/Solana"

const KnownFuelConnectors = [
    {
        id: 'bako safe',
        icon: BakoSafe
    },
    {
        id: 'fuel wallet',
        icon: Fuel
    },
    {
        id: 'fuelet wallet',
        icon: Fuelet
    },
    {
        id: 'ethereum wallets',
        icon: Ethereum
    },
    {
        id: 'solana wallets',
        icon: Solana
    }
]

export default KnownFuelConnectors